import { useState, useEffect } from "react";
import axios from "axios";
import { Play } from "lucide-react";
import AnimatedSection from "@/components/AnimatedSection";
import { getFileUrl } from "@/components/FileUpload";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Videos() {
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/videos?_t=${Date.now()}`).then(r => { setVideos(r.data); setLoading(false); }).catch(() => setLoading(false));
  }, []);

  return (
    <div className="pt-16">
      <div className="relative py-24 sm:py-32 px-6 bg-gradient-to-b from-[#8B0000]/10 to-transparent">
        <div className="max-w-6xl mx-auto">
          <p className="text-sm uppercase tracking-[0.3em] text-[#D4AF37] font-semibold mb-3">Visual</p>
          <h1 data-testid="videos-page-title" className="font-heading text-5xl sm:text-6xl lg:text-7xl">VIDEOS</h1>
          <p className="text-white/50 mt-4 max-w-lg">The vision behind the sound. Every frame tells a story.</p>
        </div>
      </div>

      <div className="px-6 pb-24">
        <div className="max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {videos.map((video, index) => (
            <AnimatedSection key={video.id} testId={`video-card-${video.id}`} delay={index * 80}>
              <div className="group relative bg-[#111111] border border-white/5 overflow-hidden card-glow">
                <div className="relative aspect-video">
                  {video.youtube_embed_url ? (
                    <iframe src={video.youtube_embed_url} className="absolute inset-0 w-full h-full" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen title={video.title} />
                  ) : (
                    <>
                      <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/30 to-transparent z-10" />
                      {video.thumbnail && <img src={getFileUrl(video.thumbnail)} alt="" className="absolute inset-0 w-full h-full object-cover" />}
                      <div className="absolute inset-0 flex items-center justify-center z-20">
                        <div className="w-14 h-14 rounded-full bg-white/10 backdrop-blur-sm flex items-center justify-center group-hover:bg-[#D4AF37]/90 group-hover:scale-110 transition-all duration-300">
                          <Play className="w-6 h-6 text-white group-hover:text-black ml-0.5" />
                        </div>
                      </div>
                      <div className="absolute inset-0 bg-[#111111] flex items-center justify-center"><Play className="w-8 h-8 text-white/5" /></div>
                    </>
                  )}
                </div>
                <div className="p-4">
                  <span className="text-[#D4AF37] text-xs uppercase tracking-wider">{video.description}</span>
                  <p className="text-white text-sm font-semibold mt-1">{video.title}</p>
                </div>
              </div>
            </AnimatedSection>
          ))}
        </div>
      </div>
    </div>
  );
}
